module.exports = __webpack_public_path__ + "static/hospital_support_card_img3@2x-de7755922ac42fc19294516e8e15da45.jpg";